function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-382ff846\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./JoinPrompt.vue")
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-382ff846\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./JoinPrompt.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./JoinPrompt.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-382ff846\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./JoinPrompt.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-382ff846",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = require("!!@kazupon/vue-i18n-loader!yaml-loader!../../node_modules/vue-loader/lib/selector?type=customBlocks&index=0!./JoinPrompt.vue")
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/JoinPrompt.vue
// module id = 353
// module chunks = 1